import { AbstractControl, ValidationErrors } from '@angular/forms';

export function securitySocialNumberValidator(acceptTemporaryValues = true) {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null) return null; // Le champ est optionnel, la validation ne s'applique que s'il y a une valeur
    let value = control.value as string;

    if (acceptTemporaryValues && (value === '199999999999999' || value === '299999999999999')) {
      return null; // Cas d'un employé étranger sans numéro de sécurité sociale
    }

    if (!value || value.length !== 15) return { invalidLength: true };
    const controlKey = value.slice(-2);
    const department = value.slice(5, 7);
    if (department === '2A' || department === '2B') {
      // Cas de la Corse, remplacer 2A par 19 et 2B par 18 pour le calcul de la clé
      value = value.replace('2A', '19').replace('2B', '18');
    }
    // Clé NIR = 97 − (13 premiers chiffres modulo 97)
    const exepectedControlKey = (97 - (Number(value.slice(0, -2)) % 97))
      .toString()
      .padStart(2, '0');
    if (controlKey === exepectedControlKey) return null;
    return { invalidControlKey: true };
  };
}
